module.exports = __webpack_public_path__ + "media/images/landkit/masks/avatar-group-7f2cba9c2f00a1930a326f3265601630.svg";